var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"legend-element"},[_c('div',{staticClass:"l-box",class:{'missing': _vm.missing},style:({ 'backgroundColor': _vm.color }),attrs:{"id":"colorbox"}}),_c('label',{attrs:{"for":"colorbox"}},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }